import { useQuery } from "@apollo/client";
import { UserActivitiesDocument } from "../../__generated__/graphql";

export default function useUserActivities({
  afterDate,
  beforeDate,
}: {
  afterDate: string | null;
  beforeDate: string | null;
}) {
  const { data, loading, error, refetch } = useQuery(UserActivitiesDocument, {
    variables: {
      filter: {
        after: afterDate,
        before: beforeDate,
      },
    },
  });

  return { data, loading, error, refetch };
}
